import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import StatsWidgetHeader from './StatsWidgetHeader';
import StatsWidgetBody from './StatsWidgetBody';
import StatsWidgetFooter from './StatsWidgetFooter';
const StatsWidget = (props) => {
    const { children, hasFilter = false, onFilterReset = () => { }, className } = props, remainingProps = __rest(props, ["children", "hasFilter", "onFilterReset", "className"]);
    const wrapperClasses = classNames('StatsWidget', className);
    return (_jsxs("div", Object.assign({}, remainingProps, { className: wrapperClasses }, { children: [hasFilter && (_jsx("span", Object.assign({ className: 'bg-light hover-bg-highlight display-flex justify-content-center align-items-center padding-2' +
                    ' rounded-circle position-absolute top-15 right-15 display-block height-20 width-20' +
                    ' cursor-pointer', onClick: onFilterReset }, { children: _jsx("span", { className: 'rioglyph rioglyph-revert text-color-white text-size-12' }) }))), children] })));
};
StatsWidget.Header = StatsWidgetHeader;
StatsWidget.Body = StatsWidgetBody;
StatsWidget.Footer = StatsWidgetFooter;
export default StatsWidget;
